import React, {useState} from "react";
import {PrimeIcons} from "primereact/api";

export function getAustragungsortDetails(tournament) {
    if( !tournament.austragungsortPLZ && !tournament.austragungsortOrt) {
        return undefined;
    }
    let austragungsDetails = "";
    if( tournament.austragungsortBezeichnung ) {
        austragungsDetails += tournament.austragungsortBezeichnung + " / ";
    }
    if( tournament.austragungsortStrasse ) {
        austragungsDetails += tournament.austragungsortStrasse + " - ";
    }
    if( tournament.austragungsortPLZ ) {
        austragungsDetails += tournament.austragungsortPLZ + " ";
    }
    if( tournament.austragungsortOrt ) {
        austragungsDetails += tournament.austragungsortOrt;
    }
    return austragungsDetails;
}

const openGoogleMaps = (event, tournament) => {
    // sonst wird zusätzlich das Event bzw. der Veranstalter geöffnet
    event.stopPropagation();
    let adresse = [tournament.austragungsortPLZ, tournament.austragungsortOrt].filter(wert => wert).join(" ");
    if( tournament.austragungsortStrasse ) {
        adresse = tournament.austragungsortStrasse + ", " + adresse;
    } else if( tournament.austragungsortBezeichnung ) {
        // ohne Strasse hilft die Bezeichnung (z.B. Sportheim) Google beim Finden
        adresse = tournament.austragungsortBezeichnung + ", " + adresse;
    }
    window.open("https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(adresse), "_blank", "noopener,noreferrer");
}

export function AustragungsortMapIcon({tournament, fontSize}) {
    if( tournament.online || !getAustragungsortDetails(tournament)) {
        return null;
    }
    return <i className={PrimeIcons.MAP_MARKER} title="In Google Maps anzeigen"
              style={{fontSize: fontSize, marginLeft: 5, padding: 4, cursor: "pointer"}}
              onClick={(event) => openGoogleMaps(event, tournament)}/>
}

/**
 * Zeigt PLZ und Ort des Austragungsorts. Sind weitere Daten (Bezeichnung, Strasse) vorhanden, können diese aufgeklappt werden.
 * Der Zustand liegt hier, damit beim Auf- und Zuklappen nicht die ganze Tabelle neu gerendert wird.
 */
export default function AustragungsortComp({tournament, fontSize, entfernung}) {

    const [aufgeklappt, setAufgeklappt] = useState(false);

    if( tournament.online || !tournament.austragungsortPLZ || !tournament.austragungsortOrt) {
        return null;
    }
    const weitereDatenVorhanden = tournament.austragungsortBezeichnung || tournament.austragungsortStrasse;
    const anzeigenAufgeklappt = weitereDatenVorhanden && aufgeklappt;
    const style = {opacity: 0.5, fontSize: fontSize};

    const changeAufgeklappt = (event) => {
        // Klick nicht an die umgebende Zeile/Zelle weitergeben
        event.stopPropagation();
        setAufgeklappt(!aufgeklappt);
    }

    return <>
        {anzeigenAufgeklappt && tournament.austragungsortBezeichnung && <><br/><span style={style}>{tournament.austragungsortBezeichnung}</span></>}
        {anzeigenAufgeklappt && tournament.austragungsortStrasse && <><br/><span style={style}>{tournament.austragungsortStrasse}</span></>}
        <br/>
        <span style={weitereDatenVorhanden ? {...style, cursor: "pointer"} : style}
              onClick={weitereDatenVorhanden ? changeAufgeklappt : undefined}>{tournament.austragungsortPLZ} {tournament.austragungsortOrt}{entfernung && " (" + entfernung + ")"}</span>
        <AustragungsortMapIcon tournament={tournament} fontSize={fontSize}/>
        {weitereDatenVorhanden &&
            <i className={anzeigenAufgeklappt ? PrimeIcons.CHEVRON_UP : PrimeIcons.CHEVRON_DOWN}
               title={anzeigenAufgeklappt ? "Weniger anzeigen" : "Mehr zum Austragungsort anzeigen"}
               style={{...style, marginLeft: 5, padding: 4, cursor: "pointer"}}
               onClick={changeAufgeklappt}/>
        }
    </>
}
